<script lang="ts">
    export let occupancies: unknown[];
    export let totalAdults: number;
    export let totalChildren: number;
</script>

<input
    class="hidden"
    name="hotel_occupancies"
    tabindex="-1"
    value={JSON.stringify(occupancies)}
/>

<input class="hidden" name="nbAdults" tabindex="-1" value={totalAdults} />

<input class="hidden" name="nbChildren" tabindex="-1" value={totalChildren} />
